<div class="form-group col-12 d-flex flex-column flex-md-row">
  <label class="switch__container">
    <input
      type="checkbox"
      class="switch__input"
      [formControl]="control"
      (change)="onChange($event.target.checked)"
      [id]="idInput"
    />
    <span class="slider round"></span>
    <span *ngIf="!control.value" class="text-off">NO</span>
    <span *ngIf="control.value" class="text-on">SI</span>
  </label>
  <span class="ml-0 ml-md-3 switch__label">
    Quiero suscribirme a la renovación automática del seguro
    <strong>{{ productName }}</strong>
  </span>
</div>
